// extracted by mini-css-extract-plugin
export default {"statusIcon":"DefineAttributes_statusIcon__KdujB","statusError":"DefineAttributes_statusError__JV11u","statusOk":"DefineAttributes_statusOk__tIgti"};